// list of valid watchlist names
export const TitleListName = {
	WATCHLIST: 'watchlist',
	SEENLIST: 'seenlist',
	LIKELIST: 'likelist',
	DISLIKELIST: 'dislikelist',
	TVST: 'tvst',
	MORELIST: 'morelist',
} as const;

export type TitleListNames = (typeof TitleListName)[keyof typeof TitleListName];
